module.exports = __webpack_public_path__ + "static/media/sky.cf119516.jpg";